import React from 'react';
import "./loader.css"
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const Loader = () => {
  return (
    // <div className='loading-container'>
    //   <div className="loader"></div>
    // </div>
    <div style={{ height: "inherit", width: "inherit", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <img src={"./assets/srkay_white.gif"} height={50} width={50} alt='loader' />
    </div>
  )
}

export default Loader

export const SkeletonContainer = () => <Skeleton width="100%" height='100%'></Skeleton>

export const SkeletonCircle = ({ numSkeletons, height, evenly }) => {
  return <div style={{ height: "inherit", width: "inherit", display: "flex", justifyContent: (evenly ? "space-evenly" : "center"), alignItems: "center" }}>
    {Array.from({ length: numSkeletons || 1 }, (_, index) => (
      <Skeleton key={index} shape="circle" size={height || "9rem"}></Skeleton>
    ))}
  </div>
}

export const SkeletonLine = ({ numSkeletons }) => {
  return Array.from({ length: numSkeletons }, (_, index) => (
    <div key={index}> <Skeleton width="100%" height='30px' className="mb-1"></Skeleton>
      <Skeleton width="75%" className="mb-1"></Skeleton>
    </div>
  ))
}

export const SkeletonCard = ({ numSkeletons, height }) => {
  return Array.from({ length: numSkeletons }, (_, index) => (
    <div className='col-md-3 col-sm-6 col-12 mb-3' key={index}  >
      <div className="border-round border-1 surface-border p-2 surface-card" style={{ height: height }}>
        <div className="d-flex gap-2 mb-3">
          <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
          <div>
            <Skeleton width="10rem" className="mb-2"></Skeleton>
            <Skeleton width="7rem" className="mb-2"></Skeleton>
            <Skeleton height=".5rem"></Skeleton>
          </div>
        </div>
        <Skeleton width="100%" height="70%"></Skeleton>
      </div>
    </div>
  ));
}

export const SkeletonProfile = () => {
  const skeletonLines = [5, 6, 5, 6, 5];
  return (
    <div className="border-round border-1 surface-border p-2 surface-card">
      <div className="d-flex gap-2 my-2">
        <Skeleton shape="circle" size="3rem" className="mr-2" />
        <div>
          <Skeleton width="10rem" className="mb-2" />
          <Skeleton width="7rem" className="mb-2" />
          <Skeleton height=".5rem" />
        </div>
      </div>
      <Skeleton width="100%" height="0.5rem" className="mb-2" />
      <div className="d-flex justify-content-between">
        {[0, 1].map(col => (
          <div className="my-2" key={col}>
            {skeletonLines.map((width, idx) => (
              <Skeleton
                key={idx}
                width={`${width}rem`}
                height="0.7rem"
                className="mb-2"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};


export const SkeletonDataTable = ({ numSkeletons, numColumns }) => {
  const items = Array.from({ length: numSkeletons ? numSkeletons : 20 }, (v, i) => i);
  const cols = Array.from({ length: numColumns ? numColumns : 6 }, (v, i) => i);
  return (
    <div className="card">
      <DataTable value={items} className="p-datatable-striped" style={{ width: numSkeletons ? "" : "94vw", height: numSkeletons ? "" : "91vh" }}>
        {cols?.map((_, index) => (
          <Column key={index} field="" header="" style={{ width: '20%' }} body={<Skeleton />}></Column>
        ))}
      </DataTable>
    </div>
  );
};

export const SkeletonCabinCard = ({ numSkeletons, height }) => {
  return Array.from({ length: numSkeletons }, (_, index) => (
    <div className='col-md-3 col-sm-6 col-12 mb-3' key={index}  >
      <div className="rounded card-container p-4 surface-card my-1" style={{ height: height, width: "100%" }}>
        <div className="d-flex justify-content-between mb-2">
          <div>
            <Skeleton width="10rem" className="mb-2"></Skeleton>
            <Skeleton width="7rem"></Skeleton>
          </div>
          <Skeleton width="5rem" height=".8rem"></Skeleton>
        </div>
        <Skeleton width="100%" height="40%"></Skeleton>
      </div>
    </div>
  ));
}

export const SkeletonTaskDetails = () => {
  return (
    <div className='d-flex'>
      <div className='w65 pe-3'>
        <Skeleton width="15rem" className="mb-3"></Skeleton>
        <div className='d-flex gap-2 mb-3'>
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton width="2rem" height="2rem"></Skeleton>
          ))}
        </div>
        <Skeleton width="7rem" height='0.7rem' className="mb-3"></Skeleton>
        <Skeleton width="100%" height='0.7rem' className="mb-2"></Skeleton>
        <Skeleton width="100%" height='0.7rem' className="mb-2"></Skeleton>
        <Skeleton width="100%" height='0.7rem' className="mb-5"></Skeleton>
        <Skeleton width="7rem" height='0.7rem' className="mb-3"></Skeleton>
        <Skeleton width="9rem" height='7rem' className="mb-5"></Skeleton>
        <Skeleton width="7rem" height='0.7rem' className="mb-2"></Skeleton>
        <div className='d-flex gap-2 mb-5 align-items-center'>
          <Skeleton width="3rem" height='0.7rem'></Skeleton>
          {Array.from({ length: 3 }, (_, index) => (
            <Skeleton width="2rem" height="2rem"></Skeleton>
          ))}
        </div>
        <div className='d-flex gap-2 w100 mb-5'>
          <Skeleton width="2rem" height="2rem" shape='circle'></Skeleton>
          <div className='w100'>
            <div className='d-flex gap-2'>
              <Skeleton width="7rem" height='0.7rem' className="mb-3"></Skeleton>
              <Skeleton width="3rem" height='0.7rem' className="mb-3"></Skeleton>
            </div>
            <Skeleton width="100%" height='0.7rem' className="mb-2"></Skeleton>
            <Skeleton width="100%" height='0.7rem' className="mb-2"></Skeleton>
            <Skeleton width="10rem" height='0.7rem'></Skeleton>
          </div>
        </div>
        <div className='d-flex gap-2 align-items-center'>
          <Skeleton width="2rem" height="2rem" shape='circle'></Skeleton>
          <Skeleton width="100%" height="2rem"></Skeleton>
        </div>
      </div>

      <div className='w35 ps-3'>
          <Skeleton width="8rem" height="2rem" className='mb-4'></Skeleton>
          {Array.from({ length: 5 }, (_, index) => (
            <div className='mb-4 d-flex gap-3 align-items-center'>
              <div className='w50'><Skeleton width="6rem" height="0.7rem"></Skeleton></div>
              <div className='d-flex gap-3 align-items-center w50'>
                {index < 2 && <Skeleton width="1.3rem" height="1.3rem" shape='circle'></Skeleton>}
                <Skeleton width="8rem" height="0.7rem"></Skeleton>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}